import React from 'react';
import EDView from '../../../../../BaseComponents/View/EDView';
import { IColumnDef } from '../../../../../Types/ColumnDefType';
import { IUIUrval } from '../../../../../Types/UrvalTypes';
import EDIconButton from '../../../../../BaseComponents/Buttons/IconButton/EDIconButton';
import { findAddComp } from '../../Const/BusinessConfigs';
import { IClientBusinessModel } from '../../../../../Types/ClientModelTypes';
import { useBoolState } from '../../../../../Hooks/booleanHooks';
import EDButton from '../../../../../BaseComponents/Buttons/Button/EDButton';
import EDIcon from '../../../../../BaseComponents/Icon/EDIcon';
import { CollectionMenuDisabledReason } from '../BusinessCollectionComponents/BusinessCollectionMenu/BusinessCollectionMenu';
import { IRenderButtonProps } from '../../Const/Delsystem';

interface IProps {
  collection: IClientBusinessModel;
  onSave: () => void;
  columns: readonly IColumnDef[];
  urval: IUIUrval;
  captionButton?: boolean;
  /** Custom render function for the trigger button. When provided, takes priority over captionButton. */
  renderButton?: (props: IRenderButtonProps) => React.ReactNode;
  baseCollection: IClientBusinessModel;
  baseId: string | null;
  hasRutinStartError: boolean;
}

/**
  Button that opens an AddNewObjectForm when clicked
*/
export const AddNewObjectButton: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  const { onSave } = props;
  const [open, openDialog, closeDialog] = useBoolState(false);
  const handleCloseDialog = React.useCallback(() => {
    closeDialog();
    onSave();
  }, [closeDialog, onSave]);
  const AddComp = findAddComp(props.collection.CollectionName);
  const title = `Lägg till ${props.collection.RootType.SOLabel}`;
  return (
    <EDView>
      {props.renderButton ? (
        props.renderButton({
          onClick: () => openDialog(),
          disabled: props.hasRutinStartError,
          title: props.hasRutinStartError
            ? CollectionMenuDisabledReason
            : undefined,
          icon: 'add',
          label: 'Lägg till',
        })
      ) : props.captionButton ? (
        <EDButton
          label="Lägg till"
          color="inherit"
          icon={<EDIcon iconType="add" color="inherit" />}
          onClick={openDialog}
          paddingY={0.5}
          labelNotUpperCase
          captionLabel
          disabled={props.hasRutinStartError}
          disabledReason={CollectionMenuDisabledReason}
          flat
        />
      ) : (
        <EDIconButton
          icon="add"
          onClick={openDialog}
          tooltip={'Lägg till'}
          disabled={props.hasRutinStartError}
          disabledReason={CollectionMenuDisabledReason}
          margin="none"
        />
      )}
      {AddComp !== undefined && (
        <AddComp
          onCancel={handleCloseDialog}
          onValuesCommited={handleCloseDialog}
          open={open}
          title={title}
          onClose={handleCloseDialog}
        />
      )}
    </EDView>
  );
};

export default AddNewObjectButton;
